

// import React, { useState, useEffect } from 'react';
// import { Box, Typography, Button, IconButton, CircularProgress, Alert } from '@mui/material';
// import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

// const ChatPopup = () => {
//   const [isOpen, setIsOpen] = useState(true);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedService, setSelectedService] = useState(null);

//   const cacheKey = 'chat_popup_services';
//   const idToken = null; // Replace with actual token if using Firebase authentication

//   // Fetch services from Firebase
//   useEffect(() => {
//     const fetchServices = async () => {
//       console.log('Fetching services from Firebase');
//       try {
//         const url = idToken
//           ? `https://armour-pro-2a88a-default-rtdb.firebaseio.com/services.json?auth=${idToken}`
//           : `https://armour-pro-2a88a-default-rtdb.firebaseio.com/services.json`;
//         const response = await fetch(url);
//         if (!response.ok) {
//           throw new Error(`Failed to fetch services: ${response.status}`);
//         }
//         const data = await response.json();
//         const serviceList = data
//           ? Object.entries(data).map(([key, value]) => ({
//               id: key,
//               name: value.name,
//               price: value.price,
//             }))
//           : [];
//         console.log('Fetched services from Firebase:', serviceList);
//         setServices(serviceList);
//         localStorage.setItem(cacheKey, JSON.stringify(serviceList));
//         setError(null);
//       } catch (err) {
//         console.error('Error fetching services:', err);
//         setError('Failed to load services');
//         // Load from cache if available
//         const cachedServices = localStorage.getItem(cacheKey);
//         if (cachedServices) {
//           try {
//             const parsed = JSON.parse(cachedServices);
//             if (Array.isArray(parsed)) {
//               setServices(parsed);
//               setError(null);
//             }
//           } catch (e) {
//             console.error('Error parsing cached services:', e);
//             localStorage.removeItem(cacheKey);
//           }
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     // Load cached services first
//     const loadCachedServices = () => {
//       const cached = localStorage.getItem(cacheKey);
//       if (cached) {
//         try {
//           const parsed = JSON.parse(cached);
//           if (Array.isArray(parsed)) {
//             setServices(parsed);
//             return true;
//           } else {
//             localStorage.removeItem(cacheKey);
//           }
//         } catch (e) {
//           console.error('Error parsing cached services:', e);
//           localStorage.removeItem(cacheKey);
//         }
//       }
//       return false;
//     };

//     const hasCachedServices = loadCachedServices();
//     setLoading(!hasCachedServices);
//     fetchServices();
//   }, []);

//   const togglePopup = () => {
//     setIsOpen(!isOpen);
//     setSelectedService(null); // Reset selected service when closing
//   };

//   const handleServiceClick = (service) => {
//     setSelectedService(service);
//   };

//   const handleBookNow = () => {
//     // Redirect to booking page
//     window.location.href = '/booking';
//   };

//   const handleNotNow = () => {
//     setSelectedService(null); // Reset to show service list
//   };

//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         bottom: 20,
//         right: 20,
//         zIndex: 1000,
//       }}
//     >
//       {/* Chat Icon (Visible when popup is closed) */}
//       {!isOpen && (
//         <IconButton
//           onClick={togglePopup}
//           sx={{
//             backgroundColor: '#1E88E5',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#1565C0' },
//             width: 60,
//             height: 60,
//             boxShadow: '0 6px 12px rgba(0,0,0,0.3)',
//             transition: 'transform 0.3s ease',
//             '&:hover': { transform: 'scale(1.1)' },
//           }}
//         >
//           <ChatBubbleIcon sx={{ fontSize: 30 }} />
//         </IconButton>
//       )}

//       {/* Popup Content (Visible when popup is open) */}
//       {isOpen && (
//         <Box
//           sx={{
//             backgroundColor: '#000',
//             borderRadius: 4,
//             boxShadow: '0 6px 20px rgba(0,0,0,0.4)',
//             width: 300,
//             p: 3,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: 2,
//             border: '1px solid #1E88E5',
//             animation: 'fadeIn 0.5s ease-in-out',
//             '@keyframes fadeIn': {
//               '0%': { opacity: 0, transform: 'translateY(20px)' },
//               '100%': { opacity: 1, transform: 'translateY(0)' },
//             },
//           }}
//         >
//           {/* Header */}
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: 'bold', color: '#fff' }}
//           >
//             Welcome to Armour Pro
//           </Typography>

//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
//               <CircularProgress size={24} sx={{ color: '#1E88E5' }} />
//             </Box>
//           ) : error ? (
//             <Alert severity="error" sx={{ color: '#fff', bgcolor: 'rgba(255, 0, 0, 0.2)' }}>
//               {error}
//             </Alert>
//           ) : selectedService ? (
//             <>
//               <Typography
//                 variant="body1"
//                 sx={{ color: '#B0BEC5', mb: 1 }}
//               >
//                 You selected: {selectedService.name} (${selectedService.price})
//               </Typography>
//               <Button
//                 variant="contained"
//                 sx={{
//                   backgroundColor: '#1E88E5',
//                   color: '#fff',
//                   textTransform: 'none',
//                   borderRadius: '50px',
//                   py: 1,
//                   '&:hover': {
//                     backgroundColor: '#1565C0',
//                     transform: 'translateY(-2px)',
//                     transition: 'all 0.3s ease',
//                   },
//                 }}
//                 onClick={handleBookNow}
//               >
//                 Book Now
//               </Button>
//               <Button
//                 variant="outlined"
//                 sx={{
//                   borderColor: '#1E88E5',
//                   color: '#fff',
//                   textTransform: 'none',
//                   borderRadius: '50px',
//                   py: 1,
//                   backgroundColor: 'rgba(30, 136, 229, 0.1)',
//                   '&:hover': {
//                     borderColor: '#fff',
//                     backgroundColor: '#1E88E5',
//                     transform: 'translateY(-2px)',
//                     transition: 'all 0.3s ease',
//                   },
//                 }}
//                 onClick={handleNotNow}
//               >
//                 Not Now
//               </Button>
//             </>
//           ) : services.length === 0 ? (
//             <Typography
//               variant="body1"
//               sx={{ color: '#B0BEC5', mb: 1 }}
//             >
//               No services available.
//             </Typography>
//           ) : (
//             <>
//               <Typography
//                 variant="body1"
//                 sx={{ color: '#B0BEC5', mb: 1 }}
//               >
//                 Which service are you looking for?
//               </Typography>
//               {/* Service Options */}
//               {services.map((service) => (
//                 <Button
//                   key={service.id}
//                   variant="outlined"
//                   sx={{
//                     borderRadius: '50px',
//                     borderColor: '#1E88E5',
//                     color: '#fff',
//                     textTransform: 'none',
//                     justifyContent: 'flex-start',
//                     py: 1,
//                     backgroundColor: 'rgba(30, 136, 229, 0.1)',
//                     '&:hover': {
//                       borderColor: '#fff',
//                       backgroundColor: '#1E88E5',
//                       transform: 'translateX(5px)',
//                       transition: 'all 0.3s ease',
//                     },
//                   }}
//                   onClick={() => handleServiceClick(service)}
//                 >
//                   {service.name} 
//                 </Button>
//               ))}
//             </>
//           )}

//           {/* Close Icon */}
//           <IconButton
//             onClick={togglePopup}
//             sx={{
//               position: 'absolute',
//               bottom: 10,
//               right: 10,
//               backgroundColor: '#1E88E5',
//               color: '#fff',
//               '&:hover': { backgroundColor: '#1565C0' },
//               width: 40,
//               height: 40,
//               boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
//               transition: 'transform 0.3s ease',
//               '&:hover': { transform: 'rotate(90deg)' },
//             }}
//           >
//             <ChatBubbleIcon sx={{ fontSize: 24 }} />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default ChatPopup;



import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

const ChatPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  const cacheKey = "chat_popup_services";
  const idToken = null;

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const url = idToken
          ? `https://armour-pro-2a88a-default-rtdb.firebaseio.com/services.json?auth=${idToken}`
          : `https://armour-pro-2a88a-default-rtdb.firebaseio.com/services.json`;
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch services");
        const data = await response.json();
        const serviceList = data
          ? Object.entries(data).map(([key, value]) => ({
              id: key,
              name: value.name,
              price: value.price,
            }))
          : [];
        setServices(serviceList);
        localStorage.setItem(cacheKey, JSON.stringify(serviceList));
        setError(null);
      } catch (err) {
        console.error("Error fetching services:", err);
        setError("Failed to load services");
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          try {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed)) {
              setServices(parsed);
              setError(null);
            }
          } catch {
            localStorage.removeItem(cacheKey);
          }
        }
      } finally {
        setLoading(false);
      }
    };

    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed)) {
          setServices(parsed);
          setLoading(false);
        } else {
          fetchServices();
        }
      } catch {
        fetchServices();
      }
    } else {
      fetchServices();
    }
  }, []);

  const togglePopup = () => {
    setIsOpen(!isOpen);
    setSelectedService(null);
  };

  const handleServiceClick = (service) => setSelectedService(service);
  const handleBookNow = () => (window.location.href = "/booking");
  const handleNotNow = () => setSelectedService(null);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
    >
      {/* Floating Chat Icon */}
      {!isOpen && (
        <IconButton
          onClick={togglePopup}
          sx={{
            backgroundColor: "#1E88E5",
            color: "#fff",
            "&:hover": { backgroundColor: "#1565C0" },
            width: 60,
            height: 60,
            boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
            transition: "transform 0.3s ease",
            "&:hover": { transform: "scale(1.1)" },
            "@media (max-width: 600px)": {
              width: 50,
              height: 50,
            },
          }}
        >
          <ChatBubbleIcon sx={{ fontSize: 28 }} />
        </IconButton>
      )}

      {/* Popup Box */}
      {isOpen && (
        <Box
          sx={{
            backgroundColor: "#000",
            borderRadius: 4,
            boxShadow: "0 6px 20px rgba(0,0,0,0.4)",
            width: 320,
            maxWidth: "95vw",
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            border: "1px solid #1E88E5",
            position: "fixed",
            bottom: 20,
            right: 20,
            animation: "fadeIn 0.4s ease-in-out",
            "@keyframes fadeIn": {
              "0%": { opacity: 0, transform: "translateY(20px)" },
              "100%": { opacity: 1, transform: "translateY(0)" },
            },
            "@media (max-width: 600px)": {
              width: "95vw",
              left: "50%",
              transform: "translateX(-50%)",
              borderRadius: "12px 12px 0 0",
              bottom: 0,
              p: 2,
              gap: 1.5,
            },
          }}
        >
          {/* Header */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#fff" }}>
            Welcome to Armour Pro
          </Typography>

          {/* Content */}
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
              <CircularProgress size={24} sx={{ color: "#1E88E5" }} />
            </Box>
          ) : error ? (
            <Alert
              severity="error"
              sx={{ color: "#fff", bgcolor: "rgba(255, 0, 0, 0.2)" }}
            >
              {error}
            </Alert>
          ) : selectedService ? (
            <>
              <Typography sx={{ color: "#B0BEC5", mb: 1 }}>
                You selected: {selectedService.name} (${selectedService.price})
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#1E88E5",
                  color: "#fff",
                  borderRadius: "50px",
                  textTransform: "none",
                  mb: 1,
                  "&:hover": { backgroundColor: "#1565C0" },
                  "@media (max-width: 600px)": { width: "100%" },
                }}
                onClick={handleBookNow}
              >
                Book Now
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "#1E88E5",
                  color: "#fff",
                  borderRadius: "50px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#1E88E5",
                    borderColor: "#fff",
                  },
                  "@media (max-width: 600px)": { width: "100%" },
                }}
                onClick={handleNotNow}
              >
                Not Now
              </Button>
            </>
          ) : services.length === 0 ? (
            <Typography sx={{ color: "#B0BEC5" }}>
              No services available.
            </Typography>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "@media (max-width: 600px)": { gap: 0.5 },
              }}
            >
              <Typography sx={{ color: "#B0BEC5", mb: 1 }}>
                Which service are you looking for?
              </Typography>
              {services.map((service) => (
                <Button
                  key={service.id}
                  variant="outlined"
                  sx={{
                    borderRadius: "50px",
                    borderColor: "#1E88E5",
                    color: "#fff",
                    textTransform: "none",
                    justifyContent: "flex-start",
                    py: 1,
                    backgroundColor: "rgba(30, 136, 229, 0.1)",
                    "&:hover": {
                      borderColor: "#fff",
                      backgroundColor: "#1E88E5",
                      transform: "translateX(5px)",
                      transition: "all 0.3s ease",
                    },
                    "@media (max-width: 600px)": { width: "100%", py: 0.8 },
                  }}
                  onClick={() => handleServiceClick(service)}
                >
                  {service.name}
                </Button>
              ))}
            </Box>
          )}

          {/* Close Icon */}
          <IconButton
            onClick={togglePopup}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#1E88E5",
              color: "#fff",
              "&:hover": { backgroundColor: "#1565C0" },
              width: 35,
              height: 35,
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
              transition: "transform 0.3s ease",
              "&:hover": { transform: "rotate(90deg)" },
            }}
          >
            <ChatBubbleIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default ChatPopup;
